// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"5b4df528","453":"32327e8b"}[chunkId] + ".chunk.js";
};